module.exports = __webpack_public_path__ + "img/DOT-icon.8443203d.svg";